<template>
  <el-dialog title="提示" :visible.sync="dialogVisible" width="25%">
    <span>请先到个人中心完善个人资料，否则无法在线报名！</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="toPersonCenter">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'Popconfirm',
  components: {},
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    toPersonCenter() {
      this.goToInfo('/personalCenter')
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped lang="scss"></style>
